import { gsap } from 'gsap'

export class IndexKv {
  constructor() {
    const kv = document.getElementById('js-index_kv')
    const mask = document.getElementById('js-index_mask')
    const slider = document.getElementById('kv-slider')
    const main = document.getElementById('js-index_main')
    const header = document.getElementById('js-header')
    const button = document.querySelector('.js-kv_button')
    const copy = document.querySelectorAll('.js-kv_copy')
    if (!kv) return

    window.addEventListener('load', () => {
      let y = window.scrollY || window.scrollTop || document.getElementsByTagName('html')[0].scrollTop
      let value = 1 + y / 100
      if (value > 10) {
        mask.style.opacity = 0
      }

      let winH = window.innerHeight
      const matrix = window.getComputedStyle(mask).getPropertyValue('transform')

      const getWindowHeight = () => {
        winH = window.innerHeight
      }
      mask.style.zIndex = 50
      mask.style.visibility = 'visible'

      window.addEventListener('resize', getWindowHeight)
      getWindowHeight()

      // スクロール
      window.addEventListener('scroll', () => {
        let y = window.pageYOffset
        if (y > winH * 3) {
          header.classList.add('is-act')
          kv.classList.add('is-hidden')
        } else {
          kv.classList.remove('is-hidden')
          header.classList.remove('is-act')
        }
      })

      // マスク部分の動き
      window.addEventListener('scroll', () => {
        let y = window.pageYOffset
        let value = 1 + y / 100
        let opacityValue = 1 - value / 10
        opacityValue = Math.max(0, opacityValue)
        if (y > 1) {
          mask.style.transform = matrix + 'scale(' + value + ')'
          mask.style.opacity = opacityValue

          // 透明度が0未満にならないように調整
          if (y > winH * 0.5) {
            kv.classList.add('is-scrolled')
            main.classList.add('is-show')
            if (value > 3) {
              mask.style.transform = matrix + 'scale(2.5)'
            }
            if (value > 6) {
              mask.style.transform = matrix + 'scale(3)'
            }
            if (value > 8) {
              button.classList.add('is-act')
              copy.forEach((elm) => {
                elm.classList.add('is-act')
              })
            }
          }
        } else {
          mask.style.transform = matrix + 'scale(1)'
          kv.classList.remove('is-scrolled')
          main.classList.remove('is-show')
          button.classList.remove('is-act')
          copy.forEach((elm) => {
            elm.classList.remove('is-act')
          })
        }
      })
    })
  }
}
